// extracted by mini-css-extract-plugin
module.exports = {"formBlock":"formBlock_formBlock__2QoV3","childrenContainer":"formBlock_childrenContainer____0mn","title":"formBlock_title__205-A","subtitle":"formBlock_subtitle__3FSc2"};